<template>
  <v-row class="ma-0" >
    <v-col align="center" style="width: 490px;font-size: 13px">
      <v-card class="new-card pa-10 elevation-10" align="center">
        <div class="text-center mb-4">
          <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
        </div>
        <h2>新学社 テスト作成システム アカウント登録 認証ページ</h2>
        <div class="bold">
          採用教師用とともにお届けしている「教師用コンテンツダウンロード案内チラシ」に記載のパスワードを、１つの枠につき１つのパスワード(英数字４文字または５文字)を入力してください。<br>
          複数学年・教科・分野をご採用の場合は、最大５つまで同時に認証できます。<br>
        </div>
        <div class="password-area">
          <v-text-field
            v-for="(materialPassword, index) in localMaterialPasswords"
            :key="index"
            v-model="materialPassword.value"
            outlined
            :error="materialPassword.error"
            @input="updateMaterialPasswords"
          ></v-text-field>
        </div>
        <div class="mb-6">
          ※案内チラシを紛失された場合や、パスワードがお分かりにならない場合は、弊社特約店までお問い合わせください。
        </div>
        <div class="warning-notice">
          <p>※1学年1教科でアカウントは1つです。複数の先生で個別にご登録はできませんので、ご注意ください。</p>
          <p>※メールアドレスの入力間違いが大変多くなっております。念のため登録完了画面でアカウント情報確認をお願いいたします。</p>
          <p class="mb-2">
            ※アカウント登録に関するお問合せはこちらまで
            <v-btn class="ml-2" small color="green" dark @click="openInquiry">問い合わせフォーム</v-btn>
          </p>
        </div>
        <div class="error-message" v-if="hasError">
          パスワードが間違っています。<br>
          採用教師用とともにお届けしている「教師用コンテンツダウンロード案内チラシ」に記載のパスワードを入力してください（英数字4文字）。<br>
          案内チラシを紛失されたり、パスワードがお分かりにならない場合は、弊社特約店までお問い合わせください。
        </div>
        <div align="right">
          <v-btn class="mt-3" color="secondary" dark @click.stop="submit">認証</v-btn>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import config from '../../config'

export default {
  data() {
    return {
      localMaterialPasswords: [],
      hasError: false
    };
  },
  created() {
    JSON.parse(JSON.stringify(this.$store.state.school.materialPasswords)).map((materialPassword) => {
      this.localMaterialPasswords.push({
        value: materialPassword,
        error: false
      })
    })
  },
  methods: {
    updateMaterialPasswords() {
      this.$store.commit('school/setMaterialPasswords', {
        materialPasswords: this.localMaterialPasswords.map(materialPassword => materialPassword.value)
      })
    },
    validate() {
      // 日常教材の認証コードチェック
      this.localMaterialPasswords.forEach((materialPassword) => {
        if (materialPassword.value === '') {
          materialPassword.error = false
          return
        }
        const subjectGradeKeys = Object.keys(config.materialPasswords).filter(key => config.materialPasswords[key].includes(materialPassword.value))
        const today = new Date()
        const shingakuSubjectGradeKeys = []
        Object.keys(config.shingakuMaterialPasswords).forEach(year => {
          const yearData = config.shingakuMaterialPasswords[year]
          const startDate = new Date(yearData.start_date)
          const endDate = new Date(yearData.end_date)
          if (today < startDate || today > endDate) return

          Object.keys(yearData.codes).forEach(key => {
            if (yearData.codes[key].includes(materialPassword.value)) {
              shingakuSubjectGradeKeys.push(key)
            }
          })
        })
        if (shingakuSubjectGradeKeys.length > 0) {
          this.$store.commit('school/setIsShingaku', {
            isShingaku: true
          })
        }
        materialPassword.error = subjectGradeKeys.length === 0 && shingakuSubjectGradeKeys.length === 0
      })

      return this.localMaterialPasswords.some(materialPassword => materialPassword.error)
    },
    submit() {
      // お試しアカウント
      if (this.localMaterialPasswords.some(materialPassword => materialPassword.value === '9999bfga9999')) {
        this.$router.push('/enrollment/new')
      }

      this.hasError = this.validate()
      if (this.hasError) return

      const nichijoSubjectGradeKeys = this.localMaterialPasswords.map(materialPassword => {
        return Object.keys(config.materialPasswords).filter(key => config.materialPasswords[key].includes(materialPassword.value))
      }).flat()

      const shingakuSubjectGradeKeys = {}
      this.localMaterialPasswords.forEach(materialPassword => {
        const today = new Date()
        const year = Object.keys(config.shingakuMaterialPasswords).find(year => {
          const yearData = config.shingakuMaterialPasswords[year]
          const startDate = new Date(yearData.start_date)
          const endDate = new Date(yearData.end_date)
          if (today < startDate || today > endDate) return false
          return Object.values(yearData.codes).flat().includes(materialPassword.value)
        })
        if (!year) return

        if (!shingakuSubjectGradeKeys[year]) {
          shingakuSubjectGradeKeys[year] = []
        }

        const keys = Object.keys(config.shingakuMaterialPasswords[year].codes).filter(key =>
          config.shingakuMaterialPasswords[year].codes[key].includes(materialPassword.value)
        )

        shingakuSubjectGradeKeys[year].push(...keys)
      })

      this.$store.commit('school/setNichijoSubjectGradeKeys', {
        nichijoSubjectGradeKeys: nichijoSubjectGradeKeys
      })

      this.$store.commit('school/setShingakuSubjectGradeKeys', {
        shingakuSubjectGradeKeys: shingakuSubjectGradeKeys
      })


      // shingakuSubjectGradeKeysのすべての値を配列として取得
      const allShingakuKeys = Object.values(shingakuSubjectGradeKeys).flat()

      // 重複を除去して結合
      this.$store.commit('school/setSubjectGradeKeys', {
        subjectGradeKeys: [...new Set([...nichijoSubjectGradeKeys, ...allShingakuKeys])],
      })

      this.$router.push('/enrollment/new')
    },
    openInquiry() {
      window.open('https://www.sing.co.jp/corp/contact/', '_blank')
    }
  }
};
</script>

<style lang="stylus" scoped>
h2
  color: #2d5aa3
  margin-bottom: 20px
  font-weight: bold
  font-size: 26px

.explanation
  width: 640px
  text-align: left

.password-area
  display: flex
  gap: 10px
  margin-top: 20px

.error-message
  color: red
  margin-top: 20px
  text-align: center
  font-weight: bold

.warning-notice
  margin-top: 30px
  color: red
  font-weight: bold
  font-size: 16px
  text-align: center
  p
    margin-bottom: 8px
</style>
